module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "mdl-button mdl-button--icon",
    on: {
      "click": _vm.download
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("file_download")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-778b131a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/elements/TableDownloadButton.vue
// module id = 531
// module chunks = 1